import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { API } from "../config";
import { IdCard, Wallet, ShieldCheck, ShieldPlus, TrafficCone, CalendarX2 } from "lucide-react";

const ICONS = [IdCard, Wallet, ShieldCheck, ShieldPlus, TrafficCone, CalendarX2];

export default function Conditions() {
  const { t, lang } = useLang();
  const [content, setContent] = useState(null);
  useEffect(() => { axios.get(`${API}/content`).then(({ data }) => setContent(data)).catch(() => {}); }, []);
  const ov = content?.cond?.[lang];
  const c = ov && ov.title
    ? { eyebrow: ov.eyebrow || t.cond.eyebrow, title: ov.title, items: ov.items?.length ? ov.items : t.cond.items }
    : t.cond;
  return (
    <section id="conditions" className="border-y-2 border-topacio-ink bg-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <p className="eyebrow mb-4">{c.eyebrow}</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-topacio-ink mb-12">{c.title}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {c.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div key={i} data-testid={`cond-item-${i}`}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                className="card-brutal p-8 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#111] transition-[transform,box-shadow]">
                <div className="w-11 h-11 bg-brand border-2 border-topacio-ink rounded-lg flex items-center justify-center shadow-[3px_3px_0_0_#111]">
                  <Icon className="w-5 h-5 text-topacio-ink" strokeWidth={2.2} />
                </div>
                <h3 className="font-display text-base font-bold text-topacio-ink mt-5">{item.t}</h3>
                <p className="text-sm text-topacio-faded mt-2 leading-relaxed">{item.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
